// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.weather-background[data-v-7eae4246] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  background: linear-gradient(135deg, #233845 0%, #1a2a35 50%, #1a2a35 100%);
}
#weather-canvas[data-v-7eae4246] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;
  z-index: 1;
}
.background-overlay[data-v-7eae4246] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(35, 56, 69, 0.6) 0%,
    rgba(26, 42, 53, 0.6) 50%,
    rgba(26, 42, 53, 0.6) 100%
  );
  z-index: 2;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/Auth/LeftSection/WeatherBackground.vue"],"names":[],"mappings":";AA+BA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,0EAA0E;AAC5E;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,UAAU;EACV,oBAAoB;AACtB","sourcesContent":["<template>\n  <div class=\"weather-background\">\n    <canvas id=\"weather-canvas\"></canvas>\n    <div class=\"background-overlay\"></div>\n  </div>\n</template>\n\n<script>\nimport { useWeatherAnimation } from \"../../../js/useWeatherAnimation\";\n\nexport default {\n  name: \"WeatherBackground\",\n  data() {\n    return {\n      disposeWeatherAnimation: null,\n    };\n  },\n  mounted() {\n    const { initializeWeatherAnimation } = useWeatherAnimation();\n    this.disposeWeatherAnimation = initializeWeatherAnimation();\n  },\n  beforeUnmount() {\n    if (typeof this.disposeWeatherAnimation === \"function\") {\n      this.disposeWeatherAnimation();\n      this.disposeWeatherAnimation = null;\n    }\n  },\n};\n</script>\n\n<style scoped>\n.weather-background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  background: linear-gradient(135deg, #233845 0%, #1a2a35 50%, #1a2a35 100%);\n}\n\n#weather-canvas {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n  z-index: 1;\n}\n\n.background-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    135deg,\n    rgba(35, 56, 69, 0.6) 0%,\n    rgba(26, 42, 53, 0.6) 50%,\n    rgba(26, 42, 53, 0.6) 100%\n  );\n  z-index: 2;\n  pointer-events: none;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
